module.exports = __webpack_public_path__ + "static/img/ic_pass.f211cf7b.png";